module.exports = __webpack_public_path__ + "img/yangruimian.18d8d97d.jpg";